import { render, staticRenderFns } from "./TeamInvitationModal.vue?vue&type=template&id=8800efb2&scoped=true"
import script from "./TeamInvitationModal.vue?vue&type=script&lang=js"
export * from "./TeamInvitationModal.vue?vue&type=script&lang=js"
import style0 from "./TeamInvitationModal.vue?vue&type=style&index=0&id=8800efb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8800efb2",
  null
  
)

export default component.exports